import http from "@/settings/apiSettings"

class DrepturiCustomDataService {
  get(data1: string, data2: string, deptId?: string | null): Promise<any> {
  const params: any = { data1, data2 };

  if (deptId) {
    params.deptId = deptId;
  }

  return http.clientResurseUmane.get("/Angajati/GetActiveEmployees", {
    params
  });
  }
  getDepartamente(): Promise<any> {
    return http.clientResurseUmane.get("/Angajati/GetPER_StructsWithFullName");
  }
  getLookup(employeeId: string): Promise<any> {
    return http.clientResurseUmane.get(`/Angajati/lookup/${employeeId}`);
  }



async SimulareSalarii(
  dataStart: Date,
  dataEnd: Date,
  angajatId: string | null,
  esteCompanie: boolean
): Promise<Blob> {
  // transformăm toate valorile în string

  const body = [
    { Name: "Data", Value: dataStart, Type: "DateTime" },
    { Name: "Par", Value: (-1).toString(), Type: "Int32" },
    { Name: "PunctLucruID", Value: null, Type: "Guid" }, // null -> string gol
    { Name: "DataEnd", Value: dataEnd, Type: "DateTime" },
    { Name: "AngajatID", Value: angajatId ?? null, Type: "Guid" }, // null -> ""
    { Name: "Utilizator", Value: "raportTest", Type: "String" },
    { Name: "Centralizator", Value: esteCompanie.toString(), Type: "Boolean" } // boolean -> string
  ];

  console.log("Body trimis:", body);

  const response = await http.clientRapoarte.post(
    "/Report/GetReport?reportID=A4A47595-05E5-4188-B254-F3E6A419CDE7&reportDesignID=07B278D1-FA92-4CCD-A1DA-3025D88EDEF5",
    body,
    { responseType: "blob" } // important pentru PDF
  );

  return response.data;
}

}

export default new DrepturiCustomDataService();